import { RenewalFormTranslations } from '../types';

export const renewalForm: RenewalFormTranslations = {
  title: "Renovação de Matrícula 2026/2027",
  subtitle: "Reserve a vaga do seu filho/a para o próximo ano letivo. O período de renovação está aberto até 17 de março.",
  earlyBirdActive: "🎉 Aproveite o desconto de reserva antecipada! Reserve antes de 23 de fevereiro e economize 50€ por criança na matrícula.",
  earlyBirdEnded: "O período de desconto de reserva antecipada terminou (23 de fevereiro).",
  contactInfo: "Informações de Contato",
  childrenInfo: "Crianças a Matricular",
  paymentPreference: "Preferência de Pagamento",
  optionalServices: "Serviços Adicionais de Interesse",
  educationalCommitment: "Compromisso Educacional",
  pricingSummary: "Resumo de Custos",
  parentName: "Nome do Pai/Mãe/Tutor",
  email: "E-mail",
  phone: "Telefone",
  childName: "Nome da Criança",
  birthDate: "Data de Nascimento",
  currentLevel: "Nível Atual",
  renewalLevel: "Nível para 2026/2027",
  isCurrentStudent: "Esta criança está atualmente matriculada na Gándara",
  isCurrentStudentHelper: "Desmarque esta caixa se for um irmão/irmã novo que não está atualmente no centro",
  comments: "Comentários ou Perguntas",
  commentsPlaceholder: "Você tem alguma pergunta ou circunstância especial que gostaria de compartilhar conosco?",
  levels: {
    infantil3: "Infantil 3 anos",
    infantil4: "Infantil 4 anos",
    infantil5: "Infantil 5 anos",
    primary1: "Primária - 1º ano",
    primary2: "Primária - 2º ano",
    primary3: "Primária - 3º ano",
    primary4: "Primária - 4º ano",
    primary5: "Primária - 5º ano",
    primary6: "Primária - 6º ano",
    infantil: "Infantil (3 a 6 anos)",
    primary: "Primária C1 (6 a 8 anos)",
    primaryC2: "Primária C2 (9 a 11 anos)"
  },
  paymentMonthly: "Pagamento Mensal (10 pagamentos)",
  paymentAnnual: "Pagamento Anual (1 pagamento)",
  annualSavings: "Economize 200€ por criança com pagamento anual",
  transport: "Transporte",
  transportPricing: "225€/mês ida e volta (mínimo 4 lugares)",
  comedor: "Refeitório",
  comedorPricing: "195€/mês 5 dias · 125€ 3 dias · 90€ 2 dias · 15€ dia avulso",
  aulaMadruga: "Aula Madruga",
  aulaMadrugaPricing: "75€/mês por família (desde as 8:15)",
  servicesNote: "Os preços mostrados são informativos. A contratação de serviços adicionais é gerida separadamente.",
  commitmentTitle: "Compromisso Educacional 2026/2027",
  commitmentText: `As pessoas abaixo assinantes manifestam que a relação família - escola será regida por um espírito de colaboração mútua e confiança para contribuir e incidir conjuntamente na educação e formação das crianças. E para isso manifestam conhecer que:

1. Gándara International School (GIS) é um centro docente estrangeiro, autorizado pela Xunta de Galicia e acreditado como escola internacional pela NEASC (New England Association of Schools and Colleges) para o segundo ciclo da Educação Infantil e para a etapa da Educação Primária. A sua oferta é o ensino privado no seu centro de Gondomar, situado no Lugar de Moureira, número 1, paróquia de Mañufe, e baseado numa pedagogia ativa e vivencial.

2. A duração do presente compromisso compreende o ano letivo 2026/2027, começando o dito ano em 1 de setembro de 2026. Tal duração poderá ser objeto de RENOVAÇÃO anualmente quando se abra o processo de reserva de vaga, sempre que exista consentimento expresso e escrito outorgado pelos pais da criança e pelo próprio Centro.

3. O programa e plano de estudos do centro estará regido pelo Calendário Escolar da Comunidade Autónoma da Galiza.

4. O Centro reger-se-á pelas Normas do Plano de Convivência, Plano de Proteção do Menor, Regulamento de Regime Interior e demais políticas internas do centro.

5. As famílias deverão transmitir informação verídica e completa sobre o filho/a no processo de admissão, sobretudo nos aspetos relativos à saúde, alergias, intolerâncias e toda a informação que possa ser de relevância para um adequado desenvolvimento do menor.

6. Não contando o centro com uma equipa multidisciplinar para ACNEAE, caso surjam essas NEAE, os progenitores/tutores comprometem-se a fornecer uma avaliação externa com especialistas apropriados e/ou apoio específico através de terapias externas. Igualmente, os diagnósticos, tratamentos e relatórios emitidos pelos terapeutas externos deverão ser transmitidos ao centro a fim de poder trabalhar em colaboração com esses gabinetes e alcançar evoluções favoráveis. O centro reserva-se o direito de não concordar com a linha pedagógica seguida pelo gabinete escolhido pelos progenitores/tutores.

7. Em caso de incumprimento deste compromisso, bem como das demais normas publicadas no website do centro e à disposição de todos os pais/tutores, este poderá ser resolvido pelo Centro, tendo como possibilidade a não renovação da vaga para o ano seguinte e/ou adotar as medidas expressamente previstas em cada caso.`,
  commitmentAccept: "Li e aceito o Compromisso Educacional para o ano letivo 2026/2027",
  privacyAccept: "Li a informação sobre proteção de dados",
  summaryTitle: "Seu Resumo de Custos",
  summaryMatricula: "Matrícula",
  summaryMonthly: "Mensalidade",
  summaryAnnual: "Anual",
  summaryEarlyBird: "Desconto matrícula antecipada",
  summaryAnnualDiscount: "Desconto pagamento anual",
  summaryTotal: "Total Anual (10 meses)",
  summaryGrandTotal: "TOTAL A PAGAR",
  summaryNote: "Os serviços adicionais não estão incluídos no total",
  summaryPerMonth: "x 10 meses",
  summaryPerYear: "ano",
  // Payment timing clarity
  summaryPayNow: "A Pagar Agora (transferência bancária)",
  summaryBankTransferNote: "Realizar transferência em agosto antes do início do ano letivo",
  summaryPayDuringYear: "Pagamentos Durante o Ano Letivo",
  summaryMonthlyPayments: "Mensalidades (set-jun)",
  summaryMonthlyBreakdown: "10 pagamentos mensais de setembro a junho",
  summaryPayAnnual: "Pagamento Anual (setembro)",
  summaryAnnualBase: "Total anual",
  summaryAnnualTotal: "Total com desconto",
  summaryAnnualNote: "Pagamento único em setembro",
  siblingLabels: {
    first: "1º irmão/irmã",
    second: "2º irmão/irmã",
    third: "3º+ irmão/irmã"
  },
  addChild: "Adicionar Outra Criança",
  removeChild: "Remover",
  submit: "Confirmar Renovação",
  submitting: "Enviando...",
  success: "Renovação confirmada! Redirecionando para a página de confirmação...",
  error: "Erro ao enviar a renovação. Por favor, tente novamente ou entre em contato conosco.",
  suggestedLevel: "Com base na data de nascimento, sugerimos o nível:",
  allChildrenNewWarning: "Você marcou todas as crianças como novos alunos. Isso está correto? Novos alunos têm preços diferentes dos de renovação.",
  required: "Este campo é obrigatório",
  invalidEmail: "O e-mail não é válido",
  invalidPhone: "O telefone deve ter pelo menos 9 dígitos",
  invalidDate: "A data não é válida",
  futureDateError: "A data de nascimento não pode ser futura",
  oldDateWarning: "Esta data sugere uma idade de {age} anos. Por favor, confirme se está correta.",
  atLeastOneChild: "Você deve adicionar pelo menos uma criança"
};
